export const SUPPORT_SESSION_ROLES = new Set([
  'OWNER', 'MODERATOR', 'ENGINEER', 'BILLING_ADMIN', 'SECURITY_ADMIN',
  'SALES_MGR', 'SUPPORT_AGENT', 'SUPPORT_MGR', 'COMPLIANCE_MOD',
]);

export const ROLE_SUBDOMAIN_MAP = Object.freeze({
  OWNER: 'supports',
  MODERATOR: 'supports',
  ENGINEER: 'supports',
  BILLING_ADMIN: 'supports',
  SECURITY_ADMIN: 'supports',
  SALES_MGR: 'supports',
  SUPPORT_AGENT: 'supports',
  SUPPORT_MGR: 'supports',
  COMPLIANCE_MOD: 'supports',
  PATIENT: 'patients',
  PATIENT_PRIMARY: 'patients',
  PATIENT_COMANAGER: 'patients',
  PATIENT_ADOLESCENT: 'patients',
  CLINIC: 'clinics',
  CLINIC_OWNER: 'clinics',
  CLINIC_MANAGER: 'clinics',
  CLINIC_DENTIST: 'clinics',
  CLINIC_ASSISTANT: 'clinics',
  CLINIC_FRONT_DESK: 'clinics',
  LAB: 'labs',
  LAB_OWNER: 'labs',
  LAB_MANAGER: 'labs',
  LAB_SENIOR_TECH: 'labs',
  LAB_JUNIOR_TECH: 'labs',
  LAB_DISPATCH: 'labs',
  SUPPLIER: 'suppliers',
  SUPPLIER_OWNER: 'suppliers',
  SUPPLIER_CATALOG: 'suppliers',
  SUPPLIER_SALES: 'suppliers',
  SUPPLIER_BILLING: 'suppliers',
  SUPPLIER_WAREHOUSE: 'suppliers',
  WASTE_MANAGEMENT: 'waste-management',
  WASTE_OWNER: 'waste-management',
  WASTE_DISPATCH: 'waste-management',
  WASTE_COMPLIANCE: 'waste-management',
  WASTE_DRIVER: 'waste-management',
  REPAIR_SERVICE: 'repair-service',
  REPAIR_OWNER: 'repair-service',
  REPAIR_DISPATCH: 'repair-service',
  REPAIR_TECHNICIAN: 'repair-service',
  REPAIR_PARTS: 'repair-service',
  REPAIR_BILLING: 'repair-service',
  TRACKING: 'tracking',
  LOGISTICS_OWNER: 'tracking',
  LOGISTICS_DISPATCH: 'tracking',
  LOGISTICS_COURIER: 'tracking',
  LOGISTICS_SUPPORT: 'tracking',
  LOGISTICS_BILLING: 'tracking',
});

export function portalForSession(session) {
  if (!session?.user) return null;
  return session.user.subdomain || ROLE_SUBDOMAIN_MAP[session.user.role] || 'patients';
}

export function evaluatePortalAccess(portal, session) {
  if (portal === 'status') {
    return Object.freeze({ allowed: true, reason: 'public_status', redirectPortal: null });
  }
  if (!session?.user) {
    return Object.freeze({ allowed: false, reason: 'authentication_required', redirectPortal: null });
  }

  const expectedPortal = portalForSession(session);
  if (portal === 'supports') {
    const hasCapability = session.capabilities?.includes('support:portal:access') === true;
    if (!hasCapability) {
      return Object.freeze({
        allowed: false,
        reason: 'support_capability_denied',
        redirectPortal: expectedPortal === 'supports' ? null : expectedPortal,
      });
    }
  }

  if (portal !== expectedPortal) {
    return Object.freeze({
      allowed: false,
      reason: 'wrong_host',
      redirectPortal: expectedPortal,
    });
  }
  return Object.freeze({ allowed: true, reason: 'allowed', redirectPortal: null });
}
